import {get, post } from './http'
import {Process } from './host'

/* 获取模板id */
export const getTemplateId = p => post('/iplat/cms/front/getPageIndex', p);

/* 获取用户信息 */
export const getUserName = p => post('/iplat/cms/common/getUserName', p);

/* 验证账号 */
export const checkUserName = p => post('/iplat/valid/user', p);

/* 验证匹配账号密码 */
export const verifiCation = p => get('/iplat/verification/user/verificationUsername', p);

/* 验证码 */
export const checkCaptcha = p => post(`${Process.env.VUE_APP_CYCORE}/fif_captcha/checkCaptcha`, p);

/* 获取手机号验证码 */
export const getValidateCode = p => post('/iplat/bp/mobile/sendValidateCodeV41', p);

/* 验证验证码 */
export const checkVerification = p => post('/iplat/bp/mobile/checkVerificationCodeV41', p);

/* 提交新密码 */
export const resetPassWord = p => post('/iplat/bp/mobile/resetPassV41', p);

/* page3 */
// 获取头部图标
export const contentList = p => post('/iplat/cms/front/contentList', p);
// 获取应用信息
export const getApplication = p => post('/iplat/bp/common/getAllApplication', p);
// 获取轮播
export const getBannerImg = p => post('/iplat/cms/front/contentList', p);

/* page2 */
// 获取模分类
export const getareaList = p => post('/iplat/cms/front/areaList', p);
export const getContentList = p => post('/iplat/cms/front/contentList', p);
export const getChannelList = p => post('/iplat/cms/front/channelList', p);
export const getHeadLogo = p => post('/iplat/cms/front/contentList', p);
export const getNoticeList = p => post('/iplat/cms/front/contentList', p);

/* page1 */
export const getAllAppList = p => post('/iplat/bp/common/getAllApplication', p);

// 退出校园账号
export const ShoolLogout = p => get(`http://in.aiit.edu.cn:8080/uaac-server/logout?service=https%3A%2F%2F${Process.env.VUE_APP_CYCORE_HOST}%2Fcas-server`, p)


// New api
// 获取学校应用接口 
export const getApps = p => get('/iplat/cms/front/homePageAppList', p);

// 加载首页信息  
export const getHomePage = p => get('/iplat/cms/front/homePageData', p);

// 获取更多新闻
export const getAllList = p => post('/iplat/cms/front/getMoreNews', p);

// export const akthref = p => post('/iplat/bp/member/akthref', p);

// 修改密码
//export const changePwds = p => post('/iplat/bp/member/updatePwdNew', p);
export const akthref = p => post('/iplat/bp/member/akthref', p);

// 修改密码
export const changePwds = p => post('/iplat/bp/member/updatePwdNew', p);




// WEBPACK FOOTER //
// ./src/request/api.js